const ROLES = {
  CANDIDATE: 'candidate',
  EMPLOYER: 'employer',
  AGENCY: 'agency',
};

export default ROLES;
